import React from "react";
import AysncMultiSelect from "../components/Input/AsyncMultiSelect";
import MultiSelect from "../components/Input/MultiSelect";
import AppLayout from "../components/Layout/AppLayout";

export default function TestPage() {
  return (
    <div className="flex justify-center items-center min-h-[calc(100vh-80px)]">
      <AysncMultiSelect />
    </div>
  );
}
